import { ArrowDownIcon, RightIcon } from '@/components/icons'
import { useUnits } from '@/hooks/useUnits'
import { HydraulicType } from '@/types/hydraulic'
import {
  IconButton,
  Stack,
  TableCell,
  TableRow,
  TableRowProps,
} from '@mui/material'
import { useState } from 'react'

interface IProps extends TableRowProps {
  expandedParent?: boolean
  row: HydraulicType
}

const HydraulicTableRow = (props: IProps) => {
  const { expandedParent, row, ...trProps } = props
  const [isExpanded, setIsExpanded] = useState<boolean>(true)
  const { convertFromMetric } = useUnits()

  const toggle = () => {
    if (row.subPipes.length === 0) {
      setIsExpanded(isExpanded)
    } else {
      setIsExpanded(!isExpanded)
    }
  }

  return (
    <>
      <TableRow {...trProps}>
        <TableCell scope="row">
          <Stack
            direction="row"
            alignItems="center"
            sx={
              Number(row.level) === 1
                ? {}
                : Number(row.level) === 3
                ? {
                    paddingLeft: '60px',
                    paddingRight: 0,
                  }
                : { paddingLeft: '34px' }
            }
          >
            <Stack sx={{ paddingRight: '20px' }}>
              {Number(row.level) !== 3 ? (
                <IconButton
                  aria-label="expand row"
                  size="small"
                  onClick={toggle}
                  sx={{
                    ...(row.subPipes.length === 0 && {
                      opacity: 0.5,
                      pointerEvents: 'none',
                      userSelect: 'none',
                    }),
                  }}
                >
                  {isExpanded && row.subPipes.length !== 0 ? (
                    <ArrowDownIcon />
                  ) : (
                    <RightIcon />
                  )}
                </IconButton>
              ) : (
                <Stack sx={{ width: '26px' }}></Stack>
              )}
            </Stack>
          </Stack>
        </TableCell>
        <TableCell>{row.id}</TableCell>

        <TableCell sx={{ borderRight: '1px solid #d7d7d7' }}>
          {row.description}
        </TableCell>

        <TableCell>
          {row.capacity
            ? convertFromMetric(
                (Math.round(row.capacity * 100) / 100).toFixed(2),
                'l/m',
              )
            : 0}
        </TableCell>
      </TableRow>

      {(row.subPipes || []).length > 0 &&
        (row.subPipes || []).map((r) => (
          <HydraulicTableRow
            sx={{
              ...(!isExpanded && {
                display: 'none !important',
              }),
            }}
            expandedParent={isExpanded}
            row={r}
            key={r.id}
          />
        ))}
    </>
  )
}

export default HydraulicTableRow
